// Client-side a11y patches for 3rd party code

// TSA Wait Times plugin
function labelTsaWaitBars() {
  const bars = document.querySelectorAll(
    '.tsa-progress-bar[role="progressbar"]:not([aria-label]):not([aria-labelledby])'
  );

  bars.forEach(bar => {
    const timeslot = bar.closest('.tsa-row')?.firstElementChild?.textContent.trim();
    bar.setAttribute(
      'aria-label',
      timeslot ? `Estimated wait time at ${timeslot}` : 'Estimated wait time'
    );

    const minutes = bar.textContent.match(/\d+/)?.[0];
    if (minutes) {
      bar.setAttribute('aria-valuetext', `${minutes} ${minutes === '1' ? 'minute' : 'minutes'}`);
    }
  });
}

// Mapplic map: its directory <ul> is role="listbox" but the items aren't
// role="option", so it has no required children. The plugin renders inside the
// <mapplic-map> custom element's shadow root and mounts asynchronously, so poll
// for the shadow root, strip the role, and observe it across re-renders.
function stripMapplicListbox(root) {
  root.querySelectorAll('.mapplic-dir-items[role="listbox"]')
    .forEach(ul => ul.removeAttribute('role'));
}

function watchMapplicShadow(shadow) {
  if (shadow.__mapplicA11yWatched) return;
  shadow.__mapplicA11yWatched = true;
  stripMapplicListbox(shadow);

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      stripMapplicListbox(shadow);
    });
  }).observe(shadow, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role'],
  });
}

function watchMapplic() {
  let tries = 0;
  const poll = setInterval(() => {
    let found = false;
    document.querySelectorAll('mapplic-map').forEach(host => {
      if (host.shadowRoot) {
        found = true;
        watchMapplicShadow(host.shadowRoot);
      }
    });
    if (found || ++tries > 100) clearInterval(poll);
  }, 200);
}

// Core image "Enlarge on click" trigger binds aria-label to a value that
// resolves to null, so the button has no accessible name (and the binding wipes
// a server-set label on hydration). Name it client-side and re-apply if the
// binding clears it.
function labelLightboxTriggers() {
  document.querySelectorAll('.lightbox-trigger:not([aria-label])')
    .forEach(btn => btn.setAttribute('aria-label', 'Enlarge image'));
}

function watchLightboxTriggers() {
  if (!document.querySelector('.lightbox-trigger')) return;
  labelLightboxTriggers();
  new MutationObserver(labelLightboxTriggers).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  });
}

export default function initAccessibility() {
  document.addEventListener('DOMContentLoaded', () => {
    labelTsaWaitBars();
    watchMapplic();
    watchLightboxTriggers();
  });
}
